// PayrollDetailedSummary

import { useState } from "react";
import { Reactable } from "../../components/ui/reactable";
import { ReportPageShell } from "../../components/ui/reportPageShell";
import { PAYROLL_DETAIL_REPORTS } from "../../constants/api";
import { EmployeeDetails } from "../../components/ui/cards";

const PayrollDetailedSummary = () => {

    const [payrollDetailedSummaryData, setPayrollDetailedSummaryData] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
        const payrollDetailedSummaryColumns = [
        {
            accessor: "employee_name",
            Header: "Employee",
            sortable: true,
            fixed: true,
            filterable: true,
            maxWidth: "300px",
            Cell: ({ value, row }) => {
                const record = row;

                let empDetails = {
                    ...record?.employee,
                    designation_id: record?.employee?.designation
                        ? {
                            id: record?.employee.designation.id,
                            designation_name: record?.employee.designation.name,
                        }
                        : { id: 0, designation_name: "" },
                    first_name: record?.employee?.employee_name || "-",
                    id: record?.employee?.employee_id || "-",
                };

                return <EmployeeDetails details={empDetails} size="xs" />;
            },
        },
        {
            // Already a display label from the API (SALARY_TYPE_LABELS), so there
            // is nothing to map here. The CSV/PDF cell differs only in casing,
            // because tools.utils.format_string capitalizes every export value.
            accessor: "salary_type",
            Header: "Salary Type",
            sortable: true,
            Cell: ({ value }) => value || "-",
        },
        {
            accessor: "earnings",
            Header: "Earning",
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "ctc",
            Header: "CTC/Month",
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "deductions",
            Header: "Deductions",
            filterable: true,
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "net_pay",
            Header: "Net Pay",
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "lop",
            Header: "LOP",
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "reimbursements",
            Header: "Reimbursements",
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "credits",
            Header: "Credits",
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "debit",
            Header: "Debit",
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "paid_salary",
            Header: "Paid Salary",
            align: 'right',
            Cell: ({ value }) => value ?? "-",
        },

    ];

    return (
        <ReportPageShell title="Payroll Detailed Summary Report " count={totalRecords}>

            <Reactable
                columns={payrollDetailedSummaryColumns}
                data={payrollDetailedSummaryData}
                setData={setPayrollDetailedSummaryData}
                setTotalCount={setTotalRecords}
                url={PAYROLL_DETAIL_REPORTS}
                serverSide={true}
                rowSize="sm"
                isCSVRequired={true}
                isPDFRequired={true}
                isMonthYearRequired={true}
            />
        </ReportPageShell>
    );
}

export default PayrollDetailedSummary;